module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// ./~/through2/~/readable-stream/transform.js
// module id = 3986
// module chunks = 0